export enum dashboardPaths {
  root = '/dashboard',
}
